import axios from "axios";
import {
  USER_LOGIN,
  LOGIN_SUCCSS,
  FORGOT_PASSWORD_STATUS,
  FORGOT_PASSWORD_LINK_STATUS,
  USER_LOGOUT,
  API_STATUS,
  LOGIN_FAIL,
  IS_LOGGED_IN_ALREADY,
  E_SIGN_UPLOAD_STATUS,
  RESEND_OTP,
  OTP_AUTH,
  GET_E_SIGNATURE,
  CHANGE_PASSWORD_LINK_STATUS,
} from "./types";
import authService from "../../services/authService";
import { errorMessage } from "../../constants/responseMessages";
import { initialState } from "./initialState";

let service = new authService();

export const fetchIPAddress = async () => {
  try {
    const response = await axios.get("https://api.ipify.org?format=json");
    return response?.data?.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return null;
  }
};

export const userLogin = (body) => {
  return (dispatch) => {
    dispatch({ type: OTP_AUTH });
    dispatch({ type: USER_LOGIN });
    dispatch({ type: IS_LOGGED_IN_ALREADY, payload: false });
    service
      .Login(body)
      .then(async (response) => {
        const users = response;
        dispatch({
          //without OTP Authentication
          type: LOGIN_SUCCSS,
          payload: users,
          //with OTP Authentication
          // type: OTP_AUTH,
          // payload: {
          //   data: "",
          //   message: response.data.message,
          //   status: true,
          //   next: true,
          // },
        });

        const ipAddress = await fetchIPAddress();
        if (ipAddress) {
          service.sendIP(ipAddress, response?.data?.data?.userid);
        }
      })
      .catch((error) => {
        dispatch({
          type: OTP_AUTH,
          payload: error,
        });
      });
  };
};

export const userLogout = (showNotification) => {
  return (dispatch) => {
    service
      .userLogout()
      .then((res) => {
        if (showNotification === true) {
          dispatch({
            type: USER_LOGOUT,
            payload: {
              ...initialState.apiStatus,
              message: res.data.message,
              loader: false,
              next: true,
              apiSuccess: true,
            },
          });
          localStorage.clear();
        }
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: { message: errorMessage(error), loader: false },
        });
      });
  };
};
export const allUserLogout = (data) => {
  return (dispatch) => {
    dispatch({
      type: USER_LOGOUT,
      payload: {
        ...initialState.apiStatus,
        message: "",
        loader: false,
        next: false,
        apiSuccess: false,
      },
    });
    service
      .allUserLogout(data)
      .then((res) => {
        dispatch({
          type: USER_LOGOUT,
          payload: {
            message: "Successfully Logged Out",
            loader: false,
            next: true,
            apiSuccess: true,
          },
        });
        localStorage.clear();
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: { message: errorMessage(error), loader: false },
        });
        dispatch({
          type: USER_LOGOUT,
          payload: {
            ...initialState.apiStatus,
            message: "",
            loader: false,
            next: false,
            apiSuccess: false,
          },
        });
      });
  };
};
export function loginClear() {
  return (dispatch) => {
    dispatch({ type: LOGIN_SUCCSS, payload: "" });
  };
}
export const clearApiResponse = () => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: {},
    });
  };
};

export const clearESighUploadStatue = () => {
  return (dispatch) => {
    dispatch({
      type: E_SIGN_UPLOAD_STATUS,
      payload: { message: "", loader: false, next: false },
    });
  };
};

export const saveUserSignature = (data) => {
  return (dispatch) => {
    dispatch({
      type: E_SIGN_UPLOAD_STATUS,
      payload: { message: "", loader: true, next: false },
    });

    service
      .saveUserSignature(data)
      .then((response) => {
        dispatch({
          type: E_SIGN_UPLOAD_STATUS,
          payload: {
            message: response?.data?.message,
            loader: false,
            next: true,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: E_SIGN_UPLOAD_STATUS,
          payload: { message: errorMessage(error), loader: false, next: false },
        });
      });
  };
};
export const getUserSignature = (data) => {
  return (dispatch) => {
    dispatch({
      type: API_STATUS,
      payload: { message: "", loader: true, next: false },
    });
    service
      .getUserSignature(data)
      .then((response) => {
        dispatch({
          type: GET_E_SIGNATURE,
          payload: { data: response.data },
        });
        dispatch({
          type: API_STATUS,
          payload: {
            ...initialState.apiStatus,
            loader: false,
            next: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: API_STATUS,
          payload: { message: errorMessage(error), loader: false, next: false },
        });
      });
  };
};

export const forgotPasswordPermission = (userName, newPassword, token) => {
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD_STATUS,
      payload: { message: "", loader: true },
    });
    service
      .forgotPassword(userName, newPassword, token)
      .then((json) => {
        dispatch({
          type: FORGOT_PASSWORD_STATUS,
          payload: { message: json?.data?.message, loader: false, next: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: FORGOT_PASSWORD_STATUS,
          payload: {
            message: error?.response?.data?.message,
            loader: false,
            next: false,
          },
        });
      });
  };
};
export const forgotPasswordLink = (userName, passwordResetLink) => {
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD_LINK_STATUS,
      payload: { message: "", loader: true },
    });
    service
      .forgotPasswordLink(userName, passwordResetLink)
      .then((json) => {
        dispatch({
          type: FORGOT_PASSWORD_LINK_STATUS,
          payload: { message: json?.data?.message, loader: false, next: true },
        });
      })
      .catch((error) => {
        dispatch({
          type: FORGOT_PASSWORD_LINK_STATUS,
          payload: {
            message: error.response.data.message,
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const clearForgotPassLinkStatus = () => {
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD_LINK_STATUS,
      payload: "",
    });
  };
};

export const clearForgoPasswordStatus = () => {
  return (dispatch) => {
    dispatch({
      type: FORGOT_PASSWORD_STATUS,
      payload: "",
    });
  };
};
export function loginInAlreadyClear() {
  return (dispatch) => {
    dispatch({ type: IS_LOGGED_IN_ALREADY, payload: false });
  };
}

export function loginFailClear() {
  return (dispatch) => {
    dispatch({
      type: LOGIN_FAIL,
      payload: "",
    });
  };
}

export const submitOtp = (otp) => {
  return (dispatch) => {
    dispatch({ type: USER_LOGIN });
    service
      .submitOtp(otp)
      .then((response) => {
        const users = response;
        dispatch({
          type: LOGIN_SUCCSS,
          payload: users,
        });
      })
      .catch((error) => {
        dispatch({
          type: LOGIN_FAIL,
          payload: error,
        });
      });
  };
};

export const resendOtp = (userName) => {
  return (dispatch) => {
    dispatch({ type: USER_LOGIN });
    service
      .resendOtp(userName)
      .then((response) => {
        dispatch({
          type: RESEND_OTP,
          payload: {},
        });
      })
      .catch((error) => {
        dispatch({
          type: RESEND_OTP,
          payload: error,
        });
      });
  };
};

export const sendIP = (ip, id) => {
  return (dispatch) => {
    dispatch({ type: USER_LOGIN });
    service
      .sendIP(ip, id)
      .then((response) => {
        dispatch({
          type: RESEND_OTP,
          payload: {},
        });
      })
      .catch((error) => {
        dispatch({
          type: RESEND_OTP,
          payload: error,
        });
      });
  };
};

export const clearCheckLinkStatus = () => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD_LINK_STATUS,
      payload: { expired: false, message: "" },
    });
  };
};

export const checkLinkStatus = (hash_key) => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_PASSWORD_LINK_STATUS,
      payload: { expired: false, message: "" },
    });
    service
      .checkLinkStatus(hash_key)
      .then((res) => {
        dispatch({
          type: CHANGE_PASSWORD_LINK_STATUS,
          payload:
            res?.data?.data?.link_expired === true
              ? { expired: true, message: res?.data?.message }
              : { expired: false, message: "" },
        });
      })
      .catch((error) => {
        dispatch({
          type: CHANGE_PASSWORD_LINK_STATUS,
          payload: {
            expired: false,
            message: "",
          },
        });
      });
  };
};
